module.exports = __webpack_public_path__ + "img/sam1.4e23f8cd.jpg";